import { PLATFORM_ROOT_OPERATIONS } from './platform-root.operations.js';
/**
 * Platform Admin and Platform Root share the complete platform-management
 * operation closure. Their authority is still distinct:
 *
 * - PLATFORM_ROOT resolves with SYSTEM scope.
 * - PLATFORM_ADMIN resolves with PLATFORM scope.
 * - organization business-data operations remain absent from this bundle and
 *   require an explicit, audited delegation context.
 *
 * Reusing the root closure prevents platform navigation, descriptors, and
 * persisted role permissions from drifting when a new platform-scoped
 * operation is added.
 */
export const PLATFORM_ADMIN_OPERATIONS = [
    ...PLATFORM_ROOT_OPERATIONS,
];
